import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AnimationBuilder, Color, RouterDirection, Mode } from '@ionic/core';
import { IonButton } from '@ionic/vue';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
    color: null,
    mode: null,
    fill: null,
    buttonType: null,
    disabled: { type: Boolean },
    expand: null,
    routerDirection: null,
    routerAnimation: null,
    download: null,
    href: null,
    rel: null,
    shape: null,
    size: null,
    strong: { type: Boolean },
    target: null,
    type: null,
    rounded: { default: 'xl' },
    borderThickness: { default: 'thin' }
  },
  setup(__props: any) {

const props = __props as { color?: Color, mode?: Mode, fill?: 'clear' | 'outline' | 'solid' | 'default', buttonType?: string, disabled?: boolean, expand?: 'full' | 'block', routerDirection?: RouterDirection, routerAnimation?: AnimationBuilder | undefined, download?: string | undefined, href?: string | undefined, rel?: string | undefined, shape?: 'round' | 'circle', size?: 'small' | 'default' | 'large', strong?: boolean, target?: string | undefined, type?: 'submit' | 'reset' | 'button', rounded: 'base' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full' | 'circle', borderThickness: 'thin' | 'light' | 'base' | 'medium' | 'thick' }



const cssVars = computed(() => {
  const radius = {
    base: '0.25rem',
    sm: '0.125rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px',
    circle: '50%',
  }[props.rounded];
  const borderThickness = {
    thin: '1px',
    light: '1.5px',
    base: '2px',
    medium: '2.5px',
    thick: '3px',
  }[props.borderThickness];
  return {
    '--border-radius': radius,
    '--border-width': borderThickness,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    color: __props.color,
    fill: __props.fill,
    "button-type": __props.buttonType,
    disabled: __props.disabled,
    expand: __props.expand,
    "router-animation": __props.routerAnimation,
    "router-direction": __props.routerDirection,
    download: __props.download,
    href: __props.href,
    rel: __props.rel,
    shape: __props.shape,
    size: __props.size,
    strong: __props.strong,
    target: __props.target,
    type: __props.type,
    style: _normalizeStyle(_unref(cssVars)),
    mode: __props.mode
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["color", "fill", "button-type", "disabled", "expand", "router-animation", "router-direction", "download", "href", "rel", "shape", "size", "strong", "target", "type", "style", "mode"]))
}
}

})